/* 216 addendum 4 §8 (2)–(3) [RULED 79; ADVISOR] — THE PLACE WITHOUT ITS ADDRESS.
   Laurent, 14/10: « show Place without the adress (show only at hover) ». An
   event's automatic location is written « name, address » (utils.ts
   `resolveEventLocation`, the linked-place arm: the place's name, a comma, its
   address), so the name is what stands before the first comma; a location typed
   by hand with no comma is its own name. A booked room (`roomName`) is a name
   already and does not pass through here. The whole text stays on the hover —
   nothing is cut from the data, the invitation still carries the address.
   Read by a matter's event line (CaseEventRow) and the Agenda page's (AgendaView).
   Pure: no React, no DOM. */
export const placeNameOf = (location: unknown): string => {
  const s = typeof location === "string" ? location.trim() : "";
  if (!s) return "";
  const i = s.indexOf(",");
  return i > 0 ? s.slice(0, i).trim() : s;
};

/** The place as a line shows it, and the whole text for its hover (null when nothing is cut). */
export const placeOf = (
  ev: { roomName?: string | null; location?: string | null } | null | undefined,
): { shown: string; whole: string | null } => {
  const room = typeof ev?.roomName === "string" ? ev.roomName.trim() : "";
  if (room) return { shown: room, whole: null };
  const whole = typeof ev?.location === "string" ? ev.location.trim() : "";
  const shown = placeNameOf(whole);
  return { shown, whole: whole && whole !== shown ? whole : null };
};
